import { getCertificationsStats } from "@/services";
import { useQuery } from "@tanstack/react-query";

const CERTIFICATIONS_STATS_QUERY_KEY = ["certifications-stats"] as const;

export function useCertificationsStats() {
  return useQuery({
    queryKey: CERTIFICATIONS_STATS_QUERY_KEY,
    queryFn: async () => {
      const response = await getCertificationsStats();
      return response ?? null;
    },
    staleTime: 0,
    gcTime: 0,
  });
}
